import { Seo } from "@/components/Seo";
import { useLang } from "@/i18n";
import { WhyClara, About } from "@/components/About";

export default function AboutPage() {
  const { t } = useLang();
  return (
    <>
      <Seo title={t.seo.about.title} description={t.seo.about.description} path="/about" />
      <About h1 />
      <WhyClara />
    </>
  );
}
